module.exports = __webpack_public_path__ + "img/dep_menu@2x.512e08bf.png";